import { render, staticRenderFns } from "./RdvList.vue?vue&type=template&id=00f27943&"
import script from "./RdvList.vue?vue&type=script&lang=js&"
export * from "./RdvList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports